import { ActionsUnion, createAction } from '@housinganywhere/safe-redux';
import { Thunk } from 'ha/myredux/types';

import { reportError } from 'ha/helpers/bugsnag/reportError';

import { getSupportedResidenceCountriesFetchStatus } from '../selectors';

export enum ActionTypes {
  START = '[supportedResidenceCountries] LOAD_SUPPORTED_RESIDENCE_COUNTRIES',
  DONE = '[supportedResidenceCountries] LOAD_SUPPORTED_RESIDENCE_COUNTRIES_DONE',
  FAIL = '[supportedResidenceCountries] LOAD_SUPPORTED_RESIDENCE_COUNTRIES_FAIL',
}

export const Actions = {
  start: () => createAction(ActionTypes.START),
  done: (countries: string[]) => createAction(ActionTypes.DONE, countries),
  fail: () => createAction(ActionTypes.FAIL),
};
export type ActionsUnionType = ActionsUnion<typeof Actions>;

export const fetchSupportedResidenceCountries =
  (): Thunk =>
  (dispatch, getState, { apiV2 }) => {
    const state = getState();

    const fetchStatus = getSupportedResidenceCountriesFetchStatus(state);
    if (fetchStatus === 'success' || fetchStatus === 'loading') {
      return Promise.resolve();
    }

    dispatch(Actions.start());

    return apiV2
      .getKycCountries(state.authLogic.user?.id, {
        asCountryOfResidence: true,
      })
      .then(({ data }) => {
        dispatch(Actions.done(data.acceptedCountryCodes || []));
      })
      .catch(error => {
        reportError('Error getting the supported residence countries', {
          metaData: { error },
        });
        dispatch(Actions.fail());
      });
  };
